import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Cleave from 'cleave.js/react';
const options = {
  numeral: true,
  numeralThousandsGroupStyle: 'thousand'
};
const CreditCardAmountField = t0 => {
  const $ = _c(6);
  let field;
  let props;
  if ($[0] !== t0) {
    ({
      field,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = field;
    $[2] = props;
  } else {
    field = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== field || $[4] !== props) {
    t1 = <Cleave options={options} {...field} {...props} />;
    $[3] = field;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
CreditCardAmountField.propTypes = {
  field: PropTypes.object.isRequired
};
export default CreditCardAmountField;